// extracted by mini-css-extract-plugin
export default {"main":"ed59748c73 _589372e790","xmark":"_6d6d43a8ff","fl_img":"b585a1b7f3 _15a91a9b52"};